import { GroupTypeEnum, GroupVisibilityEnum } from "@mimber/schema"

/**
 * Group type options for form selects
 */
export const GROUP_TYPE_OPTIONS = [
  { label: "Committee", value: GroupTypeEnum.COMMITTEE },
  { label: "Chapter", value: GroupTypeEnum.CHAPTER },
  { label: "Interest Group", value: GroupTypeEnum.INTEREST_GROUP },
  { label: "Team", value: GroupTypeEnum.TEAM },
  { label: "Other", value: GroupTypeEnum.OTHER },
]

/**
 * Group visibility options for form selects
 */
export const GROUP_VISIBILITY_OPTIONS = [
  { label: "Public", value: GroupVisibilityEnum.PUBLIC },
  { label: "Private", value: GroupVisibilityEnum.PRIVATE },
  { label: "Hidden", value: GroupVisibilityEnum.HIDDEN },
]

/**
 * Shared label + color config for group type values, used to render
 * human-readable text (instead of the raw enum) in tables and detail views.
 */
export const GROUP_TYPE_CONFIG = {
  [GroupTypeEnum.COMMITTEE]: { label: "Committee", color: "blue" },
  [GroupTypeEnum.CHAPTER]: { label: "Chapter", color: "blue" },
  [GroupTypeEnum.INTEREST_GROUP]: { label: "Interest Group", color: "green" },
  [GroupTypeEnum.TEAM]: { label: "Team", color: "green" },
  [GroupTypeEnum.OTHER]: { label: "Other", color: "default" },
} as const

export type GroupTypeDisplayKey = keyof typeof GROUP_TYPE_CONFIG

const UNKNOWN_GROUP_TYPE_DISPLAY = {
  label: "Unknown",
  color: "default",
} as const

export const getGroupTypeDisplay = (type?: string | null) => {
  if (type && Object.prototype.hasOwnProperty.call(GROUP_TYPE_CONFIG, type)) {
    return GROUP_TYPE_CONFIG[type as GroupTypeDisplayKey]
  }

  return UNKNOWN_GROUP_TYPE_DISPLAY
}

/**
 * Shared label + color config for group visibility values, used to render
 * human-readable text (instead of the raw enum) in tables and detail views.
 */
export const GROUP_VISIBILITY_CONFIG = {
  [GroupVisibilityEnum.PUBLIC]: { label: "Public", color: "green" },
  [GroupVisibilityEnum.PRIVATE]: { label: "Private", color: "orange" },
  [GroupVisibilityEnum.HIDDEN]: { label: "Hidden", color: "default" },
} as const

export type GroupVisibilityDisplayKey = keyof typeof GROUP_VISIBILITY_CONFIG

const UNKNOWN_GROUP_VISIBILITY_DISPLAY = {
  label: "Unknown",
  color: "default",
} as const

export const getGroupVisibilityDisplay = (visibility?: string | null) => {
  if (
    visibility &&
    Object.prototype.hasOwnProperty.call(GROUP_VISIBILITY_CONFIG, visibility)
  ) {
    return GROUP_VISIBILITY_CONFIG[visibility as GroupVisibilityDisplayKey]
  }

  return UNKNOWN_GROUP_VISIBILITY_DISPLAY
}
